export default __webpack_public_path__ + "static/media/kira-vnc-placeholder.13742963.png";